import moment from 'moment';

export const getReportSliceDate = (slice, format = 'YYYY-MM-DD') =>
  moment(slice?.Start || slice?.End).format(format);

export const getReportSliceSigningCount = slice => {
  const signingCount = Number(slice?.SigningCount);

  if (Number.isFinite(signingCount)) {
    return signingCount;
  }

  return Array.isArray(slice?.Signings) ? slice.Signings.length : 0;
};

export const getReportSliceFeesCollected = slice => {
  const feesCollected = Number(slice?.FeesCollected);

  return Number.isFinite(feesCollected) ? feesCollected : 0;
};
